import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_BANK_BALANCES](state, data) {
    state.allBankBalances = data
  },
}
